export const courses = [
  {
    title: "Advanced React Patterns",
    status: "In Progress",
    date: "Oct 28, 2025",
    progress: 65,
    hasProgress: true,
  },
  {
    title: "Leadership & Communication",
    status: "Enrolled",
    date: "Nov 5, 2025",
    progress: null,
    hasProgress: false,
  },
  {
    title: "Cybersecurity Essentials",
    status: "Completed",
    date: "Nov 15, 2025",
    progress: 100,
    hasProgress: true,
  },
];

